import Invoice from './Invoice';

export default Invoice
export { Invoice as Base }
